import { Observable } from 'rxjs/Rx';
import * as firebase from 'firebase';
import { auth, database } from 'firebase-app';

export const listen = () => auth.observeAuthState().catch(e => console.log(e));

export const signInWithEmailAndPassword = ({ email, password }) =>
  auth.signInWithEmailAndPassword(email, password).catch(e => e);

export const signOut = () => auth.signOut().catch(e => console.log(e));

export const checkAuthorized = ({ uid, email, photoURL }) =>
  Observable.fromPromise(
    database.ref(`users/${uid}`).once('value').catch(e => console.log(e))
  ).map(snapshot => ({
    uid,
    email,
    photoURL,
    isAuthorized: snapshot.val() !== null
  }));



// WEBPACK FOOTER //
// ./src/api/auth.js